import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { CircularProgress } from '@mui/material';
import './AssinaturaSucesso.css';
import googlePlayImage from './google.b20c07ec720bfa73a943.webp'; // Importando a imagem
import logo from './logo.png';

const AssinaturaSucesso = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
      } else {
        navigate('/login'); // Se o usuário não estiver autenticado, redireciona para a página de login
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  if (!user) {
    return (
      <div className="loading-container">
        <CircularProgress color="secondary" />
        <p>Carregando...</p>
      </div>
    );
  }

  return (
    <div className="success-page">
      <div className="success-content">
        <img src={logo} alt="Carey App Logo" className="app-logo" />
        <h1>Assinatura Confirmada!</h1>
        <p>Seja muito bem vindo(a) e obrigado por assinar nosso serviço.</p>
        <p>Sua assinatura foi realizada com sucesso e agora você tem acesso completo ao Carey App!</p>
        
        <div className="app-download">
          <p>Baixe agora o app para usufruir de todas as funcionalidades da Carey! :)</p>
          <a href="https://play.google.com/store/apps/details?id=com.carey.appy.CareyAppCuidadores" target="_blank" rel="noopener noreferrer">
            <img src={googlePlayImage} alt="Google Play" className="google-play-button" />
          </a>
        </div>
 <div className="success-actions">
          <a href="/minha-conta" className="success-button">Ir para Minha Conta</a>
        </div>
      </div>
    </div>
  );
};

export default AssinaturaSucesso;
